import { useMediaQuery, useTheme } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCreationToolTip } from '~/Components';
import { PRIMARY_BLUE, FITOGRAM_BLUE_FADED_9 } from '~/Constants/Colors.constants';
import { externalUrls } from '~/Constants/Urls.constants';
import { changeLocation } from '~/Helpers/Route.helpers';
import { Button } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import fitoLogo from '../../../../Assets/Images/fitogram_pro_logo.png';

const useStyles = makeStyles(() => ({
  upgradeBannerContainer: {
    background: FITOGRAM_BLUE_FADED_9,
    padding: 15,
    margin: '30px 0 15px',
    display: 'flex',
    '& + div': {
      paddingTop: '0 !important',
    },
  },
  upgradeBannerText: {
    flex: 1,
    lineHeight: '19px',
    marginLeft: 10,
  },
  upgradeBannerTextBold: {
    fontWeight: 'bold',
    color: PRIMARY_BLUE,
  },
  upgradeBannerLogo: {
    maxHeight: 11,
    marginRight: 5,
    imageRendering: '-webkit-optimize-contrast',
  },
  upgradeBannerTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const UpgradeBanner = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const containerRef = useRef(null);
  const onExternalLinkClick = () => {
    changeLocation(`${externalUrls.PRO_URL}/upgrades`);
  };

  return (
    <div className={classes.upgradeBannerContainer} ref={containerRef}>
      <div className={classes.upgradeBannerText}>
        <>
          <div>{t('form.field.eventGroup.flexability')}</div>
          <div className={classes.upgradeBannerTextContainer}>
            <img src={fitoLogo} className={classes.upgradeBannerLogo} alt="Fitogram Logo" />
            <div className={classes.upgradeBannerTextBold} />
            {t('form.field.eventGroup.premium')}
          </div>
        </>
      </div>
      {isMobile ? (
        <ItemCreationToolTip
          title={t('form.field.eventGroup.premium.mobile')}
          containerRef={containerRef}
        />
      ) : (
        <Button onClick={onExternalLinkClick} variant="contained" size="medium">
          {t('form.field.eventGroup.moreInfo')}
        </Button>
      )}
    </div>
  );
};
